import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as xml2js from 'xml2js';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-view-data-collector-info',
  templateUrl: './view-data-collector-info.component.html',
  styleUrls: ['./view-data-collector-info.component.scss']
})
export class ViewDataCollectorInfoComponent implements OnInit {
  xmlData: any;
  public xmlItems: any;
  dataCollectionDetails: any;
  moduleNameArray: any;
  nameArray: any;
  dataCollectionAvailable = 'none'

  constructor(private activateRoute: ActivatedRoute, private service: ApifirstService, private spinnerService: NgxSpinnerService,private translate: TranslateService) { }

  ngOnInit(): void {

    this.activateRoute.queryParams.subscribe(data => {
      this.translate.use(data['language'].toLowerCase());
      this.RequestDataCollectorInfo(data['vin'], data['timestamp'], data['userName'], data['userType'], data['token']);
    })
  }

  parseXML(data: any) {
    console.log(data)
    return new Promise(resolve => {
      var k: string | number,
        arr = [],
        parser = new xml2js.Parser(
          {
            trim: true,
            explicitArray: true
          });
      parser.parseString(data,  (err: any, result: any) => {
        console.log("After parsing");
        if(result == null) {
          this.checkDataCollectionAvailable();
        } else {
          var obj = result.session;
          console.log(obj)
          resolve(obj);
        }
        
      });
    });
  }

  checkDataCollectionAvailable() {
    this.dataCollectionAvailable = 'false';
  }

  RequestDataCollectorInfo(vinNumber: string, timeStamp: any, userName: string, userType: string, token:any) {
    let time = decodeURIComponent(timeStamp.replace(" ", "+"))
    this.spinnerService.show();
    let req = {
      "createdTimeStamp": time,
      "vin": vinNumber,
      "sessionSource": ""
    }
    this.service.getDummyViewSessionDetails(req, userName, userType, token).subscribe((data: any) => {
      this.xmlData = data
      this.spinnerService.hide();
        this.parseXML(this.xmlData).then((data: any) => {
          this.xmlItems = data;  //After parsing
          console.log("Parsed Data Collection XML data",this.xmlItems)
          try {
            //for Data Collection
            this.dataCollectionAvailable = 'true';
            this.dataCollectionDetails = this.xmlItems.vehicleId[0].idData[0].vehicleValueList[0].vehicleValue
            console.log(this.dataCollectionDetails, "data")
            let val1 = [];
            let val2 = [];
            if (this.dataCollectionDetails != 'undefined') {
              for (let i of this.dataCollectionDetails) {
                if (i.$.module && i.$.name) {
                  let ar = [];
                  ar.push(i.$.module);
                  ar.push(i.$.name);
                  ar.push(i._);
                  val1.push(ar);
                }
                else {
                  let ar = [];
                  ar.push(i.$.name);
                  ar.push(i._);
                  val2.push(ar);
                }
                //     if (i.$.name == "CM_PCM_FILENAME") {
                //       this.pcmCalibrationFile = i._; // For Details tag- PCM Calibration file
                //       console.log(this.pcmCalibrationFile)
                //     }
                //     if (i.$.name == "CM_mileage") {
                //       this.Odometer = i._;
                //     }
                //     if (this.Odometer == "") {
                //       this.Odometer = "(none)"
                //     }
                //   }
                // }
                // else {
                //   this.Odometer = "(none)"
                // }
                this.moduleNameArray = val1;
                this.nameArray = val2;
              }
                console.log("moduleNameArray is", this.moduleNameArray);
                console.log("Name Array is", this.nameArray);
            }
          }
          catch {
            this.dataCollectionAvailable = 'false';
          }
        })
    })
  }
}
